<!-- 产业服务--仓储物流服务 -->
<template>
<div class="site-content">
  <div class="site-content-page">
    <div class="content-row">
      <div class="content-col col-per-70">
        <infoPageList-03 title="仓储物流服务" label="INFORMARION" :showTitle="true" :showMore="false" :showOrder="false" :infoBlock="infoBlock" :infoPage="infoPage"  :tabList="tabList" tabDefaultType="1" tabClass="list-tab-ul-1" count="10" v-on:queryPage="ccwlfw_Req"/>
      </div>
      <div class="content-col col-per-30">
        <infoList title="推荐仓库" label="HOT SERVICE":showMore="false" count="3" :infoBlock="infoBlock1" :infoPage="infoPage1" moreLink="/hyzx05" v-on:queryPage="tjck_Req"/>
        <infoList title="推荐需求" label="RECOMMEND" :showTitle="true" :showMore="false" :infoBlock="infoBlock2" :infoPage="infoPage2" v-on:queryPage="tjxq_Req" titleLength="30" count="3"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InfoPageList03 from '../block/InfoPageList03'
import CyfwInfo1 from '../module/CyfwInfo1'
import CyfwInfo2 from '../module/CyfwInfo2'
import CyfwInfo3 from '../module/CyfwInfo3'
import CyfwInfo4 from '../module/CyfwInfo4'
import CyfwInfo5 from '../module/CyfwInfo5'
import CyfwInfo6 from '../module/CyfwInfo6'
import CyfwInfo7 from '../module/CyfwInfo7'

import HyzhImgInfo from '../module/HyzhImgInfo'
import InfoList from '../block/InfoList'

export default {
  name: 'Cyfw01',
  components: {
    'infoPageList-03': InfoPageList03,
    'infoList': InfoList,
  },
  data() {
    return {
      msg: '',
      infoBlock:CyfwInfo1,
      infoPage:{},
      tabList:[{title:"仓库供应",type:'1'},{title:"仓库租赁需求",type:'2'},{title:"物流供应",type:'3'},{title:"物流需求",type:'4'},{title:"仓配一体化服务",type:'5'}],

      infoPage1:{page:{},list:[]},
      infoBlock1:CyfwInfo6,

      infoPage2:{page:{},list:[]},
      infoBlock2:CyfwInfo7,
    }
  },
  methods:{
    //仓库物流服务
    ccwlfw_Req(params){
          let that=this;
          let result={page:params};
          params.p=params.page;
          console.log('父页面查询参数：'+JSON.stringify(params));
          let type=parseInt(params.type);
          switch (type)
          {
            case 1:
              that.ckgy_Req(params);
              break;
            case 2:
              that.ckzl_Req(params);
              break;
            case 3:
              that.wlgy_Req(params);
              break;
            case 4:
              that.wlxq_Req(params);
              break;
            case 5:
              that.cpfw_Req(params);
              break;
            default :
              that.ckgy_Req(params);
          }
      },
      ckgy_Req(params){//仓库供应--1
            let that=this;
            let result={page:params};
            that.$dataApi.whSupplylists(params).then(res =>{
              //console.log('请求Vue-axios结果：'+JSON.stringify(res))
              that.msg=res.msg;
              result.list= res.data.list;
              result.page.total=res.data.total;
              that.infoPage=result;
              that.infoBlock= CyfwInfo1;
              //console.log('结束请求Vue-axios：'+JSON.stringify(result))
            });
       },
       ckzl_Req(params){//仓库租赁需求--2
             let that=this;
             let result={page:params};
             that.$dataApi.whSupplylists(params).then(res =>{
             //that.$dataApi.whRequirelists(params).then(res =>{
               //console.log('请求Vue-axios结果：'+JSON.stringify(res))
               that.msg=res.msg;
               result.list= res.data.list;
               result.page.total=res.data.total;
               that.infoPage=result;
               that.infoBlock= CyfwInfo2;
               //console.log('结束请求Vue-axios：'+JSON.stringify(result))
             });
        },
        wlgy_Req(params){//物流供应--3
              let that=this;
              let result={page:params};
              that.$dataApi.whSupplylists(params).then(res =>{
              //that.$dataApi.tpSupplylists(params).then(res =>{
                //console.log('请求Vue-axios结果：'+JSON.stringify(res))
                that.msg=res.msg;
                result.list= res.data.list;
                result.page.total=res.data.total;
                that.infoPage=result;
                that.infoBlock= CyfwInfo3;
                //console.log('结束请求Vue-axios：'+JSON.stringify(result))
              });
         },
         wlxq_Req(params){//物流需求--4
               let that=this;
               let result={page:params};
               //that.$dataApi.whSupplylists(params).then(res =>{
               that.$dataApi.tpRequirelists(params).then(res =>{
                 //console.log('请求Vue-axios结果：'+JSON.stringify(res))
                 that.msg=res.msg;
                 result.list= res.data.list;
                 result.page.total=res.data.total;
                 that.infoPage=result;
                 that.infoBlock= CyfwInfo4;
                 //console.log('结束请求Vue-axios：'+JSON.stringify(result))
               });
          },
          cpfw_Req(params){//仓配一体化服务--5
                let that=this;
                let result={page:params};
                that.$dataApi.whSupplylists(params).then(res =>{
                //that.$dataApi.wtServiceLists(params).then(res =>{
                  //console.log('请求Vue-axios结果：'+JSON.stringify(res))
                  that.msg=res.msg;
                  result.list= res.data.list;
                  result.page.total=res.data.total;
                  that.infoPage=result;
                  that.infoBlock= CyfwInfo5;
                  //console.log('结束请求Vue-axios：'+JSON.stringify(result))
                });
           },

           //推荐仓库
           tjck_Req(params){
             //params.type='policy_library';
             let that=this;
             let result={page:params};
             //params={page:1,pageSize:7,recommend_id:3};
             //console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
             that.$dataApi.whSupplylists(params).then(res =>{
                 that.msg=res.msg;
                 result.list= res.data.list;
                 result.page.total=res.data.total;
                 that.infoPage1=result;
                 // console.log('结束请求Vue-axios：'+JSON.stringify(result))
               });

           },
           //推荐需求
           tjxq_Req(params){
                 var date = new Date();
                 let that=this;
                 params.queryYear=date.getFullYear();
                 params.queryMonth=date.getMonth()+1;
                 if(this.Global.siteTabId>0){params.tag_id=this.Global.siteTabId;}
                 let result={page:params};
                 console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
                 that.$dataApi.whSupplylists(params).then(res =>{
                 //console.log('请求Vue-axios结果：'+JSON.stringify(res))
                 that.msg=res.msg;
                 result.list= res.data.list;
                 result.page.total=res.data.total;
                 that.infoPage2=result;
                 //console.log('结束请求Vue-axios：'+JSON.stringify(result))
                 });
           },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-per-70 {
  flex-grow:3;
}

.col-per-30 {
  flex-grow:1;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Cyfw01.vue